module.exports = __webpack_public_path__ + "static/lip-sync-battle-social.c930cb2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lip-sync-battle-social.png
// module id = 425
// module chunks = 114276838955818